import React, { Fragment } from 'react'

export const breakLines = (string) => {
  if (!string) { return null }
  return string.split('\n').map((item, i) => <Fragment key={i}>{item}<br/></Fragment>)
}